export type EnvsType = 'Prd' | 'Stg' | 'Local';
export type ServerTypes = 'fluentd' | 'cssVars' | 'loki';
export type IndexTypes = 'student' | 'teacher' | 'bugReport';

export type Indexes = Record<IndexTypes, string>;
export interface Server {
  protocol: string;
  host: string;
  path: string;
  src?: string;
  bugReportSrc?: string;
  indexes?: Indexes;
}

type EnvServers = Record<string, Server>;
type Env = Record<string, EnvServers>;
export const envServers: Env = {
  Prd: {
    bugReport: {
      protocol: "https:",
      host: "addbugreport-huowhcch6a-uc.a.run.app",
      path: "/"
    },
    fluentd: {
      protocol: "https:",
      host: "fluentd.mozak.klusters.centerforgamescience.org",
      path: "/copilot",
      indexes: {
        student: 'its-student-events',
        teacher: 'its-teacher-events',
        bugReport: 'its-bug-reports'
      }
    },
    loki: {
      protocol: "https:",
      host: "loki.mozak.klusters.centerforgamescience.org",
      path: "/loki/api/v1/query_range",
      src: "copilot.its-student-events",
      bugReportSrc: "copilot.its-bug-reports"
    }
  },
  Stg: {
    bugReport: {
      protocol: "https:",
      host: "addbugreport-mtdk5d4vua-uc.a.run.app",
      path: "/"
    },
    fluentd: {
      protocol: "https:",
      host: "fluentd.mozak.klusters.centerforgamescience.org",
      path: "/copilot",
      indexes: {
        student: 'its-student-stg-events',
        teacher: 'its-teacher-stg-events',
        bugReport: 'its-bug-reports-stg'
      }
    },
    loki: {
      protocol: "https:",
      host: "loki.mozak.klusters.centerforgamescience.org",
      path: "/loki/api/v1/query_range",
      src: "copilot.its-student-stg-events",
      bugReportSrc: "copilot.its-bug-reports-stg"
    }
  },
  Local: {
    bugReport: {
      protocol: "https:",
      host: "addbugreport-mtdk5d4vua-uc.a.run.app",
      path: "/"
    },
    fluentd: {
      protocol: "https:",
      host: "fluentd.mozak.klusters.centerforgamescience.org",
      path: "/copilot",
      indexes: {
        student: 'its-student-stg-events',
        teacher: 'its-teacher-stg-events',
        bugReport: 'its-bug-reports-stg'
      }
    },
   loki: {
      protocol: "https:",
      host: "loki.mozak.klusters.centerforgamescience.org",
      path: "/loki/api/v1/query_range",
      src:"copilot.its-student-stg-events",
      bugReportSrc: "copilot.its-bug-reports-stg"
    }
  }
}

export class Servers {
  private servers: EnvServers;
  public constructor (env: string) {
    this.servers = envServers[env];
  }

  private createHref(server: Server): string {
    let { protocol, host, path } = server;

    if ((typeof window !== 'undefined') && window?.location?.protocol?.toLocaleLowerCase() === 'https:') {
      protocol = 'https:';
    }
    if (protocol.slice(-1) !== ':') protocol += ':';
    if (host.substring(0, 2) !== '//') host = `//${host}`;
    if (path.substring(0, 1) !== '/') path = `/${path}`;


    return `${protocol}${host}${path}`;
  }

  public getServerHref(serverType: ServerTypes) {
    const server = this.servers[serverType];
    return this.createHref(server);
  }

  public getIndex(serverType: ServerTypes, index: IndexTypes) {
    const server = this.servers[serverType];
    return server.indexes?.[index];
  }

  public getSrc(serverType: ServerTypes) {
    return this.servers[serverType]?.src || '';
  }

  public getBugReportSrc() {
    const bugReportInfo = this.servers['bugReport'];
    return `${bugReportInfo.protocol}//${bugReportInfo.host}`;
  }
}